// extracted by mini-css-extract-plugin
export default {"legalMenuList":"AboutUsAndLegal_legalMenuList__N6i68"};